import { useContext, useMemo, useEffect } from 'react'
import { useParams, useNavigate } from "react-router-dom"

import { AppContext } from '/providers/app-context'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/template-issued-passes'
import Menu from '/components/templates/template-nav-menu'

import PassesTable from '/components/passes/passes-table'

const IssuedPasses = () => {

  const navigate = useNavigate()
  const { templateId } = useParams()
  const { loadingTemplates, templates } = useContext(AppContext)

  const template = useMemo(() => {return templates.filter(t => t.id === templateId)[0]}, [templates, templateId])

  useEffect(() => {
    if(!loadingTemplates && !template) navigate("/templates")
  },[template])

  const heading = useMemo(() => template ? `${template.name} ${template.archived ? " [archived]" : ""}` : "",[template])

  return (
    <PageWrapper title="Issued Passes" HelpText={HelpText} heading={heading} menu={<Menu template={template} />}>
      <PassesTable />
    </PageWrapper>
  )
}

export default IssuedPasses